import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ "carousel", "dotBtnContainer" ]

  async initialize() {
    window.Flickity = (await import("flickity")).default
    this._flickity = new window.Flickity(this.carouselTarget, {
      groupCells: this.carouselTarget.dataset["groupCells"] || false,
      cellAlign: 'left',
      watchCSS: true,
      autoPlay: this.carouselTarget.dataset["autoPlay"] || false,
      pauseAutoPlayOnHover: false,
      setGallerySize: (this.carouselTarget.dataset["setGallerySize"] || "true") === "true"
    })

    this._updateDotBtnsWhenDotsChange()
  }

  resize() {
    this._flickity.resize()
    this._flickity.reloadCells()
  }

  next() {
    this._flickity.next(true)
  }

  previous() {
    this._flickity.previous(true)
  }

  _updateDotBtnsWhenDotsChange() {
    const dotsContainer = this.element.querySelector(".flickity-page-dots")
    if (dotsContainer) {
      const mutationObserver = new MutationObserver(this._updateDotBtnPositions.bind(this))
      mutationObserver.observe(dotsContainer, { subtree: true, childList: true })
    }
  }

  _updateDotBtnPositions() {
    const dotCount = this._flickity.slides.length
    const totalDotWidth = dotCount * 8
    const totalDotSpacingWidth = (dotCount - 1) * 8
    const spaceBetweenDotsAndBtns = 48 // 24*2
    const buttonsSize = 80 // 40*2
    const totalWidth = totalDotWidth + totalDotSpacingWidth + spaceBetweenDotsAndBtns + buttonsSize
    this.dotBtnContainerTarget.style.width = `${totalWidth}px`
  }
}
